import { formatCurrency } from '@/helpers/format';
import { Button } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { CheckCircleTwoTone } from './Icons';
import MembershipCardModal, {
  IMembershipCardData,
} from './MembershipCardModal';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { cancelSelfSubscription, createSubscription } from '@/services/account';
import { modalType } from './Modal';

let stripePromise = null;

const load_stripe = (pkStripe) => {
  stripePromise = loadStripe(pkStripe);
};

export default function MembershipCard({
  user,
  configInfo,
  loadInfo,
  hasMemberTokenSubscription,
}) {
  const [ui, uiSet] = useState<IMembershipCardData>({
    showCard: false,
  } as IMembershipCardData);
  console.log(user);
  const cancelSubscription = async () => {
    const md = modalType({
      type: 'confirm',
      title: 'Are you sure you want to cancel your membership?',
      okText: 'Yes, please cancel',
      cancelText: 'Keep my membership',
      content: '',
      onOk: async () => {
        uiSet({ ...ui, createSubscription: true });
        md.destroy();
        try {
          const ret = await cancelSelfSubscription();
          if (ret.status != 'OK') {
            modalType({
              type: 'error',
              title: 'error',
              content: 'Error cancelling subscription',
            });
            return;
          }
          await loadInfo();
          uiSet({ ...ui, createSubscription: false });
        } catch (e) {
          modalType({
            type: 'error',
            title: 'error',
            content: 'Error cancelling subscription',
          });
          uiSet({ ...ui, createSubscription: false });
        }
      },
    });
  };
  const buyRecurrent = async () => {
    try {
      uiSet({ ...ui, createSubscription: true });
      const result = await createSubscription(user.member_login);
      if (result.status === 'OK') {
        uiSet({
          ...ui,
          showCard: true,
          createSubscription: false,
          client_secret: result.client_secret,
          customer_id: result.customer_id,
        });
        return;
      }
    } catch (e) {
      console.log(e);
    }
    modalType({
      type: 'error',
      title: 'error',
      content: 'Error creating subscription',
    });
  };

  useEffect(() => {
    if (configInfo.pkStripe) {
      load_stripe(configInfo.pkStripe);
    }
  }, [configInfo.pkStripe]);

  console.log(configInfo.membershipSubscription);
  return (
    <div className="border border-primary rounded-md overflow-hidden">
      <div className="text-sm text-primary bg-orange-50 border-b border-primary  flex flex-row items-center w-full relative p-3">
        <span className="ml-2">&nbsp;Membership</span>
        {dayjs(user.member_dt_next_payment) > dayjs() && (
          <CheckCircleTwoTone
            className="absolute right-4 text-2xl top-2.5"
            twoToneColor="#52c41a"
          />
        )}
      </div>

      {dayjs(user.member_dt_next_payment) > dayjs() ? (
        <div className="p-4">
          Your membership is valid until{' '}
          <strong>
            {dayjs(user.member_dt_next_payment).format('MM/DD/YYYY')}
          </strong>{' '}
          {hasMemberTokenSubscription ? (
            <p>
              Your membership will renew automatically. To cancel upcoming
              renewal, please click here. Your membership will remain valid
              until your current expiration date.
              <br />
              <Button
                type="primary"
                loading={ui.createSubscription}
                className="rounded-full bg-primary mt-4 mb-12 uppercase"
                onClick={() => {
                  cancelSubscription();
                }}
              >
                Cancel Subscription
              </Button>
            </p>
          ) : (
            <></>
          )}
        </div>
      ) : configInfo.membershipSubscription == 'true' ? (
        <>
          <div className="flex flex-col p-4">
            <p>
              Join our On Air Parking membership program, and we will waive our
              service fee on each reservation you book. Get your first year at a
              reduced price of{' '}
              <span className="text-primary font-bold">
                {formatCurrency({
                  value: configInfo.membershipPrice,
                  locale: 'en-US',
                  currency: 'USD',
                })}
              </span>
              , with a renewal rate of{' '}
              <span className="font-bold">
                {formatCurrency({
                  value: configInfo.membershipOldPrice,
                  locale: 'en-US',
                  currency: 'USD',
                })}
              </span>{' '}
              thereafter. Offer valid until {configInfo.membershipDate}. <br />
              <br />
              <Button
                type="primary"
                className="mt-0 mb-4 uppercase primary"
                loading={ui.createSubscription}
                onClick={() => {
                  buyRecurrent();
                }}
              >
                Join now
              </Button>
            </p>

            <p>This annual membership will renew automatically.</p>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col p-4">
            <p>
              To waive processing fee on each reservation, buy Annual Membership
              for just{' '}
              <span className="line-through">
                {formatCurrency({
                  value: configInfo.membershipOldPrice,
                  locale: 'en-US',
                  currency: 'USD',
                })}
                /year
              </span>{' '}
              <span className="text-primary font-bold">
                {formatCurrency({
                  value: configInfo.membershipPrice,
                  locale: 'en-US',
                  currency: 'USD',
                })}
                /year
              </span>{' '}
              until {configInfo.membershipDate}.
            </p>
          </div>
          <Button
            type="primary"
            className="rounded-full mt-0 mb-4 uppercase bg-primary"
            onClick={() => {
              // chama o modal do stripe aqui
              // a variavel configInfo passada como props tem o pk do stripe
              uiSet({ ...ui, showCard: true });
            }}
          >
            Buy a membership
          </Button>
        </>
      )}
      <Elements stripe={stripePromise}>
        <MembershipCardModal ui={ui} uiSet={uiSet} />
      </Elements>
    </div>
  );
}
